import { RootState } from 'src/state/rootReducer';

export const getSitesData = (state: RootState) => {
  return state.entities.sites;
};
